module.exports = require('./helpers/bundle-url').getBundleURL('ldLGp') + "logo-dark.eefe0b7f.svg";